import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import DailyImg from '../../assest/crane.jpg';
import WeeklyImg from '../../assest/Loader-3.jpg';
import MonthlyImg from '../../assest/ TrackLoader.png';

// Packages list with translations
const packagesList = (language) => [
  {
    name: {
      gb: "Daily Package",
      sa: "الحزمة اليومية",
      fr: "Forfait journalier",
      de: "Tagespaket"
    },
    image: DailyImg,
    specs: {
      gb: "Flexible daily rental with no long-term commitment.",
      sa: "إيجار يومي مرن بدون التزام طويل الأجل.",
      fr: "Location journalière flexible sans engagement à long terme.",
      de: "Flexible Tagesmiete ohne langfristige Verpflichtung."
    },
    description: {
      gb: "Ideal for short-term projects or occasional use where you only pay for what you need.",
      sa: "مثالي للمشاريع قصيرة الأجل أو الاستخدام المتقطع حيث تدفع فقط مقابل ما تحتاجه.",
      fr: "Idéal pour les projets à court terme ou une utilisation occasionnelle où vous ne payez que ce dont vous avez besoin.",
      de: "Ideal für kurzfristige Projekte oder gelegentliche Nutzung, bei der Sie nur für das bezahlen, was Sie benötigen."
    },
  },
  {
    name: {
      gb: "Weekly Package",
      sa: "الحزمة الأسبوعية",
      fr: "Forfait hebdomadaire",
      de: "Wochenpaket"
    },
    image: WeeklyImg,
    specs: {
      gb: "Cost-effective weekly rental for medium-term needs.",
      sa: "إيجار أسبوعي اقتصادي للاحتياجات متوسطة الأجل.",
      fr: "Location hebdomadaire économique pour des besoins à moyen terme.",
      de: "Kostengünstige Wochenmiete für mittelfristige Bedürfnisse."
    },
    description: {
      gb: "Perfect for projects lasting several days, offering discounted rates compared to daily rentals.",
      sa: "مثالي للمشاريع التي تستمر عدة أيام، مع تقديم أسعار مخفضة مقارنة بالإيجارات اليومية.",
      fr: "Parfait pour les projets de plusieurs jours, offrant des tarifs réduits par rapport aux locations journalières.",
      de: "Perfekt für Projekte, die mehrere Tage dauern, mit vergünstigten Preisen im Vergleich zu Tagesmieten."
    },
  },
  {
    name: {
      gb: "Monthly Package",
      sa: "الحزمة الشهرية",
      fr: "Forfait mensuel",
      de: "Monatspaket"
    },
    image: MonthlyImg,
    specs: {
      gb: "Best value for long-term rentals with maximum flexibility.",
      sa: "أفضل قيمة للإيجارات طويلة الأجل مع أقصى مرونة.",
      fr: "Meilleur rapport qualité-prix pour les locations à long terme avec une flexibilité maximale.",
      de: "Beste Preis-Leistung für Langzeitmieten mit maximaler Flexibilität."
    },
    description: {
      gb: "Designed for extended projects with significant cost savings over shorter rentals.",
      sa: "مصممة للمشاريع الممتدة مع توفير كبير في التكاليف مقارنة بالإيجارات الأقصر.",
      fr: "Conçu pour les projets prolongés avec des économies de coûts importantes par rapport aux locations plus courtes.",
      de: "Entwickelt für längerfristige Projekte mit erheblichen Kosteneinsparungen gegenüber kürzeren Mietdauern."
    },
  },
];

// Translations for Packages page
const translations = {
  gb: {
    heading: "Rental Packages",
    introText: "Choose from flexible rental options designed to meet your project duration and budget.",
    categoriesTitle: "Available Packages",
    featuredTitle: "Our Top Packages",
    featuredDescription: "Packages tailored to provide the best value for your rental needs.",
  },
  sa: {
    heading: "حزم الإيجار",
    introText: "اختر من بين خيارات إيجار مرنة مصممة لتلبية مدة مشروعك وميزانيتك.",
    categoriesTitle: "الحزم المتاحة",
    featuredTitle: "أفضل حزمنا",
    featuredDescription: "حزم مصممة لتوفير أفضل قيمة لاحتياجات الإيجار الخاصة بك.",
  },
  fr: {
    heading: "Forfaits de location",
    introText: "Choisissez parmi des options de location flexibles conçues pour répondre à la durée de votre projet et à votre budget.",
    categoriesTitle: "Forfaits disponibles",
    featuredTitle: "Nos meilleurs forfaits",
    featuredDescription: "Forfaits conçus pour offrir le meilleur rapport qualité-prix pour vos besoins de location.",
  },
  de: {
    heading: "Mietpakete",
    introText: "Wählen Sie aus flexiblen Mietoptionen, die auf Ihre Projektlaufzeit und Ihr Budget zugeschnitten sind.",
    categoriesTitle: "Verfügbare Pakete",
    featuredTitle: "Unsere Top-Pakete",
    featuredDescription: "Pakete, die den besten Wert für Ihre Mietbedürfnisse bieten."
  },
};

const Packages = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  // Process packages list with current language
  const processedPackagesList = packagesList().map(item => ({
    name: item.name[language] || item.name.gb,
    image: item.image,
    specs: item.specs[language] || item.specs.gb,
    description: item.description[language] || item.description.gb
  }));

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={processedPackagesList}
      language={language}
    />
  );
};

export default Packages;